import React from 'react';

import {useDefaultSectionsInfo} from '../../../state/panelGenHistoryKeys/panelGenHistoryKeysStore';
import {useNgwTruncatedPanelGenLimits} from '../../../util/dynamicConfigs/ngwTruncatedPanelGenLimits';
import {maybePluralize} from '../../../util/uihelpers';

/**
 * Helper text shown at the bottom of the workspace when auto-generated sections
 * have been truncated (i.e. more prefixes matched than maxPrefixGroups returned).
 */
export const WorkspaceSectionsTruncatedNotice = () => {
  const {numExcludedMatches} = useDefaultSectionsInfo();
  const {
    config: {maxMetricsPerGroup},
  } = useNgwTruncatedPanelGenLimits();

  if (!numExcludedMatches) {
    return null;
  }

  return (
    <p className="mr-auto text-sm text-wb-text-tertiary">
      <span className="font-semibold">
        {maybePluralize(numExcludedMatches, 'more section', 's', true)}{' '}
        {numExcludedMatches === 1 ? 'matches' : 'match'} your run and panel
        filters.
      </span>{' '}
      Workspaces automatically render a limited set of logged sections, with up
      to {maxMetricsPerGroup.toLocaleString()} panels each. Sections beyond this
      limit are not shown; use panel search to find them.
    </p>
  );
};
